export default __webpack_public_path__ + "static/media/favouriteAssets.df0f4671.png";